import Component from '../core/Component'

export default class SearchFormFocus extends Component {
    prepare() {
        this.element.addEventListener('click', this.handleClick)
    }

    handleClick = event => {
        event.preventDefault()

        const nav = Component.getFromElement('nav')
        if (nav.element.classList.contains('is-active')) {
            nav?.toggle()
        }

        const searchForm = document.querySelector('.scroll-Container .HeaderSearch-containerForm')
        searchForm?.classList.add('is-focused')

        const searchInput = searchForm?.querySelector('input')

        if (typeof(searchInput) != 'undefined' && searchInput != null) {
            searchInput.value = ''
            searchInput.focus()
        }
    }
}
